module.exports = __webpack_public_path__ + "img/banner .645228a7.png";